import Swiper, { Navigation } from "swiper";
import UsedVehicleFinance from '../../used-vue/api/finance/UsedVehicleFinance';
import { updateMonthlyPrices  } from './financeHelpers.js';

export const initUsedVehicles = () => {
    const slices = document.querySelectorAll('.cms-content-slice-used-vehicles');
    if (!slices.length) return;
    slices.forEach(slice => {
        const slider = slice.querySelector('.swiper');
        if (!slider) return;

        new Swiper(slider, {
            modules: [Navigation],
            grabCursor: true,
            loop: true,
            slidesPerView: 1,
            spaceBetween: 30,
            navigation: {
                nextEl: '.cms-content-slice-used-vehicles__slider-nav--next',
                prevEl: '.cms-content-slice-used-vehicles__slider-nav--prev',
            },
            breakpoints: {
                576: { slidesPerView: 2 },
                768: { slidesPerView: 3 },
                1024: { slidesPerView: 4 },
            },
            on: {
                slideChangeTransitionEnd() {
                    updateMonthlyPrices(window.usedVehicles);
                       $('.cms-content-slice-used-vehicles__details').matchHeight({
                            byRow: true,
                            property: 'height',
                            target: null,
                            remove: false
                        });
                }
            }
        });
    });

    $('.cms-content-slice-used-vehicles__details').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false
    });

    if (window.usedVehicles?.length) {
        const finance = new UsedVehicleFinance();
        finance.setVehicles(window.usedVehicles);

        finance.getFinance()
            .then(vehicles => {
                updateMonthlyPrices(vehicles);
            })
            .catch(() => console.warn('Finance calculation failed'));
    }
};